import React from "react";
import LocalizedLink from "../containers/LocalizedLink";

import CollectionsSurface from "../images/collections-surface.jpg";
import CollectionsMotif from "../images/collections-motifs.jpg";

const Collections = props => (
  <React.Fragment>
    <div className="grid grid--2 grid--double">
      <LocalizedLink
        className="grid__item"
        style={{ backgroundImage: `url(${CollectionsSurface})` }}
        to="/collections/surfaces"
      >
        <div className="grid__item-title">{props.t("titleSurfaces")}</div>
      </LocalizedLink>

      <LocalizedLink
        className="grid__item"
        style={{ backgroundImage: `url(${CollectionsMotif})` }}
        to="/collections/patterns"
      >
        <div className="grid__item-title">{props.t("titlePatterns")}</div>
      </LocalizedLink>
    </div>
  </React.Fragment>
);

export default Collections;



// WEBPACK FOOTER //
// ./src/components/Collections.js